module.exports = __webpack_public_path__ + "media/images/prizeBox__fg-505516274e8fdfafaa9de46d39c1c5b2.png";